import alt from '../alt';

/**
 * Navigation actions
 *  
 */
class NavigationActions {
	updateLocation(location) {
		return location;
	}
}

export default alt.createActions(NavigationActions);
